export const PERMISSIONS = {
  // kites
  CREATE_USER: 'CREATE_USER',
  UPDATE_USER: 'UPDATE_USER',
  DELETE_USER: 'DELETE_USER',
  GET_USER: 'GET_USER',
  GET_USER_ARCHIVED: 'GET_USER_ARCHIVED',
  UPDATE_USER_ARCHIVED: 'UPDATE_USER_ARCHIVED',

  GET_ROLE: 'GET_ROLE',
  GET_ROLES: 'GET_ROLES',
  CREATE_ROLE: 'CREATE_ROLE',
  UPDATE_ROLE: 'UPDATE_ROLE',
  DELETE_ROLE: 'DELETE_ROLE',
  GET_ROLE_ARCHIVED: 'GET_ROLE_ARCHIVED',
  UPDATE_ROLE_ARCHIVED: 'UPDATE_ROLE_ARCHIVED',

  GET_PERMISSIONS: 'GET_PERMISSIONS',
  UPDATE_PERMISSION: 'UPDATE_PERMISSION',

  CREATE_CLIENT: 'CREATE_CLIENT',
  UPDATE_CLIENT: 'UPDATE_CLIENT',
  GET_CLIENT: 'GET_CLIENT',
  GET_CLIENT_ARCHIVED: 'GET_CLIENT_ARCHIVED',
  UPDATE_CLIENT_ARCHIVED: 'UPDATE_CLIENT_ARCHIVED',

  CREATE_JOB: 'CREATE_JOB',
  UPDATE_JOB: 'UPDATE_JOB',
  GET_JOB: 'GET_JOB',
  SETTING_JOB: 'SETTING_JOB',
  VIEW_CONTRACT: 'VIEW_CONTRACT',

  GET_CATEGORY: 'GET_CATEGORY',
  CREATE_CATEGORY: 'CREATE_CATEGORY',
  UPDATE_CATEGORY: 'UPDATE_CATEGORY',

  GET_TAG: 'GET_TAG',
  CREATE_TAG: 'CREATE_TAG',
  UPDATE_TAG: 'UPDATE_TAG',

  GET_RECRUITER: 'GET_RECRUITER',
  UPDATE_RECRUITER: 'UPDATE_RECRUITER',

  GET_CANDIDATE: 'GET_CANDIDATE',
  UPDATE_CANDIDATE: 'UPDATE_CANDIDATE',

  // PAYMENT
  GET_PAYMENT: 'GET_PAYMENT',
  CREATE_PAYMENT: 'CREATE_PAYMENT',
  UPDATE_PAYMENT: 'UPDATE_PAYMENT',

  // APPLICATION
  GET_APPLICATION: 'GET_APPLICATION',
  UPDATE_APPLICATION: 'UPDATE_APPLICATION',
  CREATE_APPLICATION: 'CREATE_APPLICATION',
  DELETE_APPLICATION: 'DELETE_APPLICATION',

  // RESUME
  GET_RESUME: 'GET_RESUME',
  UPDATE_RESUME: 'UPDATE_RESUME',
  CREATE_RESUME: 'CREATE_RESUME',
  SEARCH_RESUME: 'SEARCH_RESUME',
}; 